<template>
<div class="shoppingCart_box">
	<shopCarCom></shopCarCom>
</div>
</template>

<script>
import shopCarCom from "@/components/shopCarCom";

export default {
	name: "shoppingCart",
	components: {
		shopCarCom
	},
	data() {
		return {}
	},
	methods: {},
}
</script>

<style lang="scss" scoped></style>